/**
 * Utility to resolve base paths for subdomain-aware routing.
 *
 * On subdomain (e.g. app.chain29.com) routes live at root: /sales, /orders
 * On main domain (chain29.com) routes live under prefix: /back-office/sales
 */

const detectSubdomain = () => {
  const hostname = window.location.hostname;
  if (
    hostname.includes('localhost') ||
    hostname.includes('ondigitalocean.app')
  ) {
    return null;
  }
  const parts = hostname.split('.');
  return parts.length >= 3 ? parts[0].toLowerCase() : null;
};

const subdomain = detectSubdomain();

/** Back-office base path: '' on app subdomain, '/back-office' otherwise */
export const BO_BASE = subdomain === 'app' ? '' : '/back-office';

/** Company admin base path: '' on admin/admins subdomain, '/company-admin' otherwise */
export const CA_BASE = (subdomain === 'admin' || subdomain === 'admins') ? '' : '/company-admin';

/** Build a back-office route path */
export const boPath = (route = '') => `${BO_BASE}${route ? `/${route}` : ''}` || '/';

/** Build a company-admin route path */
export const caPath = (route = '') => `${CA_BASE}${route ? `/${route}` : ''}` || '/';

/**
 * A PWA's own base: '' on its subdomain (kds.chain29.com), '/kds' or '/pwa/kds' on
 * the main host. Links inside a PWA are built with pwaPath, never a bare "/settings"
 * (that left the app on the main host) or a relative path inside a "/*" route.
 */
export const pwaBase = (app) => {
  const m = window.location.pathname.match(new RegExp(`^/(pwa/)?${app}(?=/|$)`));
  return m ? m[0] : '';
};

export const pwaPath = (app, route = '') => `${pwaBase(app)}/${String(route).replace(/^\/+/, '')}`;

/**
 * Where a PWA opens, as a link to hand to staff: https://pos.chain29.com on the production
 * hosts (one app per subdomain; the device signs in to the restaurant), /pos (path
 * routing) on localhost / *.ondigitalocean.app / the bare domain. Never the back office's
 * own origin + /pos/<slug>: app.chain29.com/pos/... is the back office (-> dashboard).
 */
export const pwaUrl = (sub, localPath = `/${sub}`) => {
  const { hostname, protocol, port, origin } = window.location;
  const parts = hostname.split('.');
  const local = hostname.includes('localhost') || hostname.includes('ondigitalocean.app');
  if (!local && parts.length >= 3) return `${protocol}//${sub}.${parts.slice(1).join('.')}${port ? `:${port}` : ''}`;
  if (!local && parts.length === 2) return `${protocol}//${sub}.${hostname}${port ? `:${port}` : ''}`;
  return `${origin}${localPath}`;
};
